
import { FileText } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Investment } from "@/types/investment";
import { formatDate, formatCurrency } from "./utils";

interface OriginalContractCardProps {
  investment: Investment;
}

const OriginalContractCard = ({ investment }: OriginalContractCardProps) => {
  const originalBalance = investment.originalSalesPrice && investment.originalDownPayment 
    ? investment.originalSalesPrice - investment.originalDownPayment 
    : null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center text-blue-800">
          <FileText className="h-5 w-5 mr-2" />
          Original Contract Terms
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {investment.salesDate && (
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Sales Date:</span>
            <span className="font-semibold">{formatDate(investment.salesDate)}</span>
          </div>
        )}
        {investment.originalSalesPrice && (
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Original Sales Price:</span>
            <span className="font-semibold">{formatCurrency(investment.originalSalesPrice)}</span>
          </div>
        )}
        {investment.originalDownPayment && (
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Down Payment:</span>
            <span className="font-semibold">{formatCurrency(investment.originalDownPayment)}</span>
          </div>
        )}
        {originalBalance && (
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Original Balance:</span>
            <span className="font-semibold">{formatCurrency(originalBalance)}</span>
          </div>
        )}
        {investment.originalTerm && (
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Original Term:</span>
            <span className="font-semibold">{investment.originalTerm} months</span>
          </div>
        )}
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Interest Rate:</span>
          <span className="font-semibold">{investment.interestRate}%</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Monthly Payment:</span>
          <span className="font-semibold">{formatCurrency(investment.monthlyPayment)}</span>
        </div>
        {investment.hasBalloonPayment && investment.balloonPaymentAmount && (
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Balloon Payment:</span>
            <span className="font-semibold">{formatCurrency(investment.balloonPaymentAmount)}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default OriginalContractCard;
